<template>
  <div class="py-5">
    <v-card-title>
      Ecrire les témoignages
    </v-card-title>
    <div class="d-flex flex-row flex-wrap justify-start">
      <div
        v-for="(temoignage, index) in temoignagesAbonnement"
        :key="index"
        class="card-width mx-3 my-4"
      >
        <Temoignage
          :temoignage="temoignage"
          @delete="onDeleteTemoignage(temoignage)"
          @edit="onEditTemoignage(temoignage)"
        />
      </div>
      <div class="card-width mx-3 my-4">
        <AjoutTemoignage @ajout-temoignage="onAjoutTemoignage" />
      </div>
    </div>
    <v-dialog
      v-model="isOpenModalEditTemoignage"
      fullscreen
      transition="slide-x-transition"
    >
      <EditTemoignageAbonnementModal
        v-if="isOpenModalEditTemoignage"
        :temoignage="temoignageEnModification"
        @close="onCloseEditTemoignage()"
      />
    </v-dialog>
    <v-dialog
      v-model="isOpenModalConfirmDelete"
      persistent
      width="500"
    >
      <ConfirmModal
        cancel-text="Non"
        confirm-text="Oui"
        title="Confirmation"
        @cancel="onCancelDeleteContenu"
        @confirm="onConfirmDeleteContenu"
      >
        <p>Attention, vous souhaitez supprimer le témoignage.</p>
        <p>Voulez-vous vraiment continuer ?</p>
      </ConfirmModal>
    </v-dialog>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import AjoutTemoignage from '@/views/admin/temoignage/components/ajout-temoignage.vue'
import EditTemoignageAbonnementModal from '@/views/admin/temoignage/components/modal/edit-temoignage-abonnement-modal.vue'
import Temoignage from '@/views/admin/temoignage/components/temoignage.vue'
import ConfirmModal from '@/components/modal/confirm-modal.vue'

export default {
  name: 'TemoignageAbonnementAdmin',
  components: {ConfirmModal, Temoignage, EditTemoignageAbonnementModal, AjoutTemoignage},
  data () {
    return {
      loading: false,
      erreur: false,
      isOpenModalEditTemoignage: false,
      isOpenModalConfirmDelete: false,
      temoignageEnModification: null,
    }
  },

  computed: {
    ...mapGetters({
      temoignagesAbonnement: 'temoignageAbonnement/temoignagesAbonnement'
    })
  },

  created () {
    this.loadTemoignagesAbonnement()
  },

  methods: {
    ...mapActions({
      getAllTemoignages : 'temoignageAbonnement/getAllTemoignages',
      deleteTemoignageAbonnement : 'temoignageAbonnement/deleteTemoignageAbonnement'
    }),

    loadTemoignagesAbonnement () {
      this.loading = true
      this.erreur = false

      this.getAllTemoignages()
        .catch(() => this.erreur = true)
        .finally(() => this.loading = false)
    },

    onAjoutTemoignage () {
      this.temoignageEnModification = null
      this.isOpenModalEditTemoignage = true
    },

    onEditTemoignage (temoignage) {
      this.temoignageEnModification = temoignage
      this.isOpenModalEditTemoignage = true
    },

    onCloseEditTemoignage () {
      this.temoignageEnModification = null
      this.isOpenModalEditTemoignage = false
    },

    onDeleteTemoignage (temoignage) {
      this.temoignageEnModification = temoignage
      this.isOpenModalConfirmDelete = true
    },

    onCancelDeleteContenu () {
      this.isOpenModalConfirmDelete = false
      this.temoignageEnModification = null
    },

    onConfirmDeleteContenu () {
      this.loading = true
      this.erreur = false
      this.isOpenModalConfirmDelete = false

      this.deleteTemoignageAbonnement(this.temoignageEnModification.id)
        .catch(() => this.erreur)
        .finally(() => {
          this.temoignageEnModification = null
          this.loading = false
        })
    },
  }
}
</script>

<style lang="scss" scoped>
.card-width {
  width: 350px;
}

</style>
